// Mock data for AKM Laser website

export const machines = {
  co2: [
    {
      id: 'co2-1',
      name: 'LaserCO2 Pro 1000',
      slug: 'laser-co2-pro-1000',
      power: '100W',
      workArea: '1000 x 600 mm',
      tableHeight: '250 mm',
      materials: ['Bois', 'Acrylique', 'Cuir', 'Tissu', 'Papier', 'Carton'],
      price: 'Sur devis',
      image: 'https://images.unsplash.com/photo-1615286922420-c6b348ffbd62?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsYXNlciUyMGVuZ3JhdmluZ3xlbnwwfHx8fDE3NzUyMDg3OTB8MA&ixlib=rb-4.1.0&q=85',
      gallery: [
        'https://images.unsplash.com/photo-1615286922420-c6b348ffbd62?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsYXNlciUyMGVuZ3JhdmluZ3xlbnwwfHx8fDE3NzUyMDg3OTB8MA&ixlib=rb-4.1.0&q=85',
        'https://images.pexels.com/photos/7254410/pexels-photo-7254410.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
        'https://images.pexels.com/photos/7254462/pexels-photo-7254462.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
      ],
      description: 'Machine laser CO2 idéale pour gravure et découpe de matériaux non métalliques. Parfaite pour artisans et créateurs.',
      longDescription: 'Machine laser CO2 professionnelle conçue pour les artisans, créateurs et TPE. Fiable, performante et accessible, elle vous permet de graver et découper une grande variété de matériaux avec précision.',
      features: ['Gravure haute précision', 'Découpe rapide', 'Logiciel intuitif inclus', 'Formation complète'],
      technicalSpecs: {
        cooling: 'Refroidissement : circulation d\'eau avec refroidisseur CW3000',
        voltage: 'Tension : 220 V - 50/60 Hz',
        tableTypes: [
          { name: 'Nid d\'abeille', description: 'Idéal pour la gravure et la découpe de petites pièces' },
          { name: 'Lames', description: 'Parfaite pour les matériaux épais et la découpe propre' }
        ]
      },
      includedEquipment: [
        'Compresseur à air - Pour améliorer la qualité de découpe et protéger le tube laser',
        'Échangeur d\'eau avec contrôle de température - Refroidissement sécurisé du tube pour des performances optimales',
        'Logiciel de gravure inclus - Prise en main rapide, compatible avec vos fichiers de création',
        'Formation initiale de 4h offerte - Apprenez à utiliser la machine et le logiciel efficacement (sur place ou à distance)',
        'Support technique réactif - En visio, par téléphone ou e-mail, même après la formation'
      ],
      availableOptions: [
        'Tourne-cylindre pour graver sur mugs, verres, bouteilles',
        'Tube laser 80W pour plus de puissance',
        'Table de découpe supplémentaire'
      ],
      deliveryOptions: [
        {
          title: 'Retrait à l\'atelier (Moidieu - 38 ou Lyon - 69)',
          items: [
            'Idéal pour les modèles compacts (ex: R40, petits CO2, fibre)',
            'Sur place, nous assurons :',
            '• La remise de la machine testée & prête à l\'emploi',
            '• L\'installation du logiciel sur votre ordinateur',
            '• Une formation de prise en main directement dans nos locaux'
          ]
        },
        {
          title: 'Livraison & installation chez vous (sur devis)',
          items: [
            'Recommandé pour les équipements plus volumineux',
            'Nous livrons la machine dans vos locaux et assurons sur place :',
            '• L\'installation complète',
            '• La configuration du logiciel sur votre ordinateur',
            '• Une formation pour démarrer sereinement'
          ]
        }
      ],
      warranty: {
        machine: '2 ans (retour atelier)',
        parts: '12 mois'
      },
      materialCompatibility: [
        { material: 'Bois & dérivés (bambou, MDF, etc.)', engrave: true, cut: true },
        { material: 'Acrylique', engrave: true, cut: true },
        { material: 'Verre', engrave: true, cut: false },
        { material: 'Papier', engrave: true, cut: true },
        { material: 'Tissu', engrave: true, cut: true },
        { material: 'Cuir', engrave: true, cut: true },
        { material: 'Caoutchouc', engrave: true, cut: true },
        { material: 'Contreplaqué', engrave: true, cut: true },
        { material: 'Fibre de verre', engrave: true, cut: false },
        { material: 'Métal peint', engrave: true, cut: false }
      ],
      applications: [
        'Gravure et découpe d\'enseignes, panneaux et signalétiques (bois, acrylique, métal peint, etc.)',
        'Personnalisation d\'objets : trophées, cadeaux d\'entreprise, goodies promotionnels',
        'Découpe laser de maquettes, prototypes et objets décoratifs',
        'Production artisanale ou industrielle de bijoux, pièces mécaniques, plaques de porte, objets déco, maroquineries',
        'Gravure et marquage sur plastiques, cuir, tissus et matériaux composites'
      ],
      youtubeVideo: 'dQw4w9WgXcQ'
    },
    {
      id: 'co2-2',
      name: 'LaserCO2 Expert 1300',
      slug: 'laser-co2-expert-1300',
      power: '130W',
      workArea: '1300 x 900 mm',
      tableHeight: '250 mm',
      materials: ['Bois', 'Acrylique', 'Cuir', 'Tissu', 'Verre (gravure)', 'MDF'],
      price: 'Sur devis',
      image: 'https://images.pexels.com/photos/7254410/pexels-photo-7254410.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      gallery: [
        'https://images.pexels.com/photos/7254410/pexels-photo-7254410.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
        'https://images.unsplash.com/photo-1615286922420-c6b348ffbd62?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsYXNlciUyMGVuZ3JhdmluZ3xlbnwwfHx8fDE3NzUyMDg3OTB8MA&ixlib=rb-4.1.0&q=85'
      ],
      description: 'Machine professionnelle pour production intensive. Grande surface de travail pour projets ambitieux.',
      longDescription: 'Machine laser CO2 haute performance pour les professionnels exigeants. Surface de travail étendue et puissance élevée pour vos productions en série.',
      features: ['Grande zone de travail', 'Puissance élevée', 'Système de refroidissement optimisé', 'Support technique 24/7'],
      technicalSpecs: {
        cooling: 'Refroidissement : circulation d\'eau avec refroidisseur CW5000',
        voltage: 'Tension : 220 V - 50/60 Hz',
        tableTypes: [
          { name: 'Nid d\'abeille', description: 'Idéal pour la gravure et la découpe de petites pièces' },
          { name: 'Lames', description: 'Parfaite pour les matériaux épais et la découpe propre' }
        ]
      },
      includedEquipment: [
        'Compresseur à air professionnel',
        'Échangeur d\'eau CW5000 avec contrôle de température',
        'Logiciel de gravure professionnel inclus',
        'Formation initiale de 6h offerte',
        'Support technique prioritaire 24/7'
      ],
      availableOptions: [
        'Tourne-cylindre pour graver sur mugs, verres, bouteilles',
        'Table motorisée automatique',
        'Système d\'aspiration renforcé'
      ],
      deliveryOptions: [
        {
          title: 'Retrait à l\'atelier (Moidieu - 38 ou Lyon - 69)',
          items: ['Machine testée & prête à l\'emploi', 'Installation du logiciel', 'Formation sur place']
        },
        {
          title: 'Livraison & installation chez vous (sur devis)',
          items: ['Installation complète', 'Configuration logiciel', 'Formation démarrage']
        }
      ],
      warranty: {
        machine: '2 ans (retour atelier)',
        parts: '12 mois'
      },
      materialCompatibility: [
        { material: 'Bois & dérivés', engrave: true, cut: true },
        { material: 'Acrylique', engrave: true, cut: true },
        { material: 'Verre', engrave: true, cut: false },
        { material: 'MDF', engrave: true, cut: true },
        { material: 'Tissu', engrave: true, cut: true },
        { material: 'Cuir', engrave: true, cut: true }
      ],
      applications: [
        'Production en série de pièces découpées',
        'Signalétique professionnelle grand format',
        'Prototypage rapide',
        'Personnalisation d\'objets volumineux'
      ],
      youtubeVideo: 'dQw4w9WgXcQ'
    },
    {
      id: 'co2-3',
      name: 'LaserCO2 Studio 600',
      power: '60W',
      workArea: '600 x 400 mm',
      materials: ['Bois', 'Acrylique', 'Cuir', 'Papier', 'Carton'],
      price: 'Sur devis',
      image: 'https://images.pexels.com/photos/7254462/pexels-photo-7254462.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      description: 'Solution compacte pour débutants et petits ateliers. Idéale pour démarrer votre activité laser.',
      features: ['Format compact', 'Facile à utiliser', 'Prix accessible', 'Formation incluse']
    }
  ],
  fiber: [
    {
      id: 'fiber-1',
      name: 'LaserFibre Metal 2000',
      power: '2000W',
      workArea: '3000 x 1500 mm',
      materials: ['Acier', 'Inox', 'Aluminium', 'Cuivre', 'Laiton'],
      price: 'Sur devis',
      image: 'https://images.unsplash.com/photo-1598302936625-6075fbd98dd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxtZXRhbCUyMGN1dHRpbmd8ZW58MHx8fHwxNzc1MjA4NzkzfDA&ixlib=rb-4.1.0&q=85',
      description: 'Machine laser fibre pour découpe métal industrielle. Performance et précision pour vos productions.',
      features: ['Découpe métal haute vitesse', 'Précision extrême', 'Faible consommation', 'Maintenance réduite']
    },
    {
      id: 'fiber-2',
      name: 'LaserFibre Compact 1500',
      power: '1500W',
      workArea: '2000 x 1000 mm',
      materials: ['Acier', 'Inox', 'Aluminium'],
      price: 'Sur devis',
      image: 'https://images.unsplash.com/photo-1764114440880-9bdbfe570a4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxtZXRhbCUyMGN1dHRpbmd8ZW58MHx8fHwxNzc1MjA4NzkzfDA&ixlib=rb-4.1.0&q=85',
      description: 'Solution fibre compacte pour ateliers métallurgiques. Rapport qualité-prix optimal.',
      features: ['Encombrement réduit', 'Haute efficacité', 'Interface simplifiée', 'Fiabilité industrielle']
    },
    {
      id: 'fiber-3',
      name: 'LaserFibre Pro 3000',
      power: '3000W',
      workArea: '4000 x 2000 mm',
      materials: ['Acier', 'Inox', 'Aluminium', 'Cuivre', 'Laiton', 'Titane'],
      price: 'Sur devis',
      image: 'https://images.unsplash.com/photo-1582655024629-2073de041286?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxtZXRhbCUyMGN1dHRpbmd8ZW58MHx8fHwxNzc1MjA4NzkzfDA&ixlib=rb-4.1.0&q=85',
      description: 'La référence en découpe métal. Pour industries exigeantes et production intensive.',
      features: ['Très grande surface', 'Puissance maximale', 'Production en série', 'Système automatisé']
    }
  ],
  mixed: [
    {
      id: 'mixed-1',
      name: 'LaserMixte Hybrid 1000',
      power: 'CO2 100W + Fibre 30W',
      workArea: '1000 x 600 mm',
      materials: ['Tous matériaux', 'Métal et non-métal'],
      price: 'Sur devis',
      image: 'https://images.unsplash.com/photo-1705164008429-26fb279468b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxsYXNlciUyMGN1dHRpbmclMjBtYWNoaW5lfGVufDB8fHx8MTc3NTIwODc4Nnww&ixlib=rb-4.1.0&q=85',
      description: 'Machine hybride unique : travaillez métal ET matériaux organiques sur une seule machine.',
      features: ['Double technologie', 'Polyvalence totale', 'Gain de place', 'Rentabilité optimale']
    },
    {
      id: 'mixed-2',
      name: 'LaserMixte Universal 1300',
      power: 'CO2 130W + Fibre 50W',
      workArea: '1300 x 900 mm',
      materials: ['Tous matériaux', 'Métal et non-métal'],
      price: 'Sur devis',
      image: 'https://images.unsplash.com/photo-1738162837438-92ff852619a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxsYXNlciUyMGN1dHRpbmclMjBtYWNoaW5lfGVufDB8fHx8MTc3NTIwODc4Nnww&ixlib=rb-4.1.0&q=85',
      description: 'Solution universelle pour tous vos besoins laser. Investissement intelligent pour diversifier votre activité.',
      features: ['Technologies combinées', 'Flexibilité maximale', 'Formation double', 'Un seul SAV']
    }
  ]
};

export const services = [
  {
    id: 'service-1',
    icon: 'Settings',
    title: 'Installation complète',
    description: 'Nous installons et configurons votre machine laser clé en main. Mise en route rapide et sans stress.'
  },
  {
    id: 'service-2',
    icon: 'GraduationCap',
    title: 'Formation personnalisée',
    description: 'Formation complète à la machine et au logiciel. Vous repartez autonome et confiant pour vos premiers projets.'
  },
  {
    id: 'service-3',
    icon: 'Headphones',
    title: 'SAV réactif',
    description: 'Support technique rapide par téléphone, email ou à distance. Nous sommes là quand vous en avez besoin.'
  },
  {
    id: 'service-4',
    icon: 'Users',
    title: 'Accompagnement projet',
    description: 'Conseils personnalisés pour choisir la machine adaptée à vos besoins et votre budget.'
  }
];

export const testimonials = [
  {
    id: 'testi-1',
    name: 'Marie Dupont',
    company: 'Atelier Créatif MD',
    role: 'Artisan créateur',
    text: 'Après un achat raté sur internet, AKM Laser m\'a sauvé ! Formation au top, machine performante, et surtout un vrai suivi. Je recommande à 100%.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop'
  },
  {
    id: 'testi-2',
    name: 'Jean-Pierre Martin',
    company: 'Métallerie JP Martin',
    role: 'Métallier',
    text: 'La machine fibre a transformé mon activité. Découpe rapide, précise, et l\'équipe AKM est toujours disponible pour mes questions. Excellent investissement.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop'
  },
  {
    id: 'testi-3',
    name: 'Sophie Lemoine',
    company: 'Design & Co',
    role: 'Designer',
    text: 'Machine mixte parfaite pour ma diversité de projets. Le conseil d\'AKM m\'a permis de choisir le bon équipement. Très satisfaite !',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop'
  }
];

export const realizations = [
  {
    id: 'real-1',
    title: 'Signalétique bois personnalisée',
    category: 'CO2',
    client: 'Restaurant Le Gourmet',
    image: 'https://images.unsplash.com/photo-1574149501304-9eb7931b08ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxsYXNlciUyMGVuZ3JhdmluZ3xlbnwwfHx8fDE3NzUyMDg3OTB8MA&ixlib=rb-4.1.0&q=85',
    description: 'Gravure laser haute précision sur bois massif pour enseigne de restaurant. Rendu professionnel et durable.'
  },
  {
    id: 'real-2',
    title: 'Découpe métal industrielle',
    category: 'Fibre',
    client: 'Industrie Mécanique Pro',
    image: 'https://images.unsplash.com/photo-1600181897467-dcdadfe88cd4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxsYXNlciUyMGVuZ3JhdmluZ3xlbnwwfHx8fDE3NzUyMDg3OTB8MA&ixlib=rb-4.1.0&q=85',
    description: 'Découpe de précision sur acier inoxydable. Production en série avec qualité constante.'
  },
  {
    id: 'real-3',
    title: 'Objets déco acrylique',
    category: 'CO2',
    client: 'Boutique Déco Tendance',
    image: 'https://images.pexels.com/photos/7254410/pexels-photo-7254410.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    description: 'Création de décorations murales en acrylique gravé et découpé. Design moderne et épuré.'
  },
  {
    id: 'real-4',
    title: 'Pièces métalliques sur-mesure',
    category: 'Fibre',
    client: 'Atelier Mécanique Dupuis',
    image: 'https://images.unsplash.com/photo-1455165814004-1126a7199f9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwbWFudWZhY3R1cmluZ3xlbnwwfHx8fDE3NzUyMDg4MDF8MA&ixlib=rb-4.1.0&q=85',
    description: 'Fabrication de pièces métalliques complexes avec tolérances serrées. Qualité industrielle.'
  },
  {
      id: 'real-5',
    title: 'Gravure cuir premium',
    category: 'CO2',
    client: 'Maroquinerie Artisanale',
    image: 'https://images.pexels.com/photos/7254462/pexels-photo-7254462.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    description: 'Personnalisation de produits en cuir haut de gamme. Finition irréprochable et détails raffinés.'
  },
  {
    id: 'real-6',
    title: 'Production mixte multi-matériaux',
    category: 'Mixte',
    client: 'Atelier Création Moderne',
    image: 'https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwbWFudWZhY3R1cmluZ3xlbnwwfHx8fDE3NzUyMDg4MDF8MA&ixlib=rb-4.1.0&q=85',
    description: 'Projets combinant métal et matériaux organiques. Polyvalence maximale avec une seule machine.'
  }
];

export const faqs = [
  {
    id: 'faq-1',
    question: 'Quelle est la différence entre laser CO2 et laser fibre ?',
    answer: 'Le laser CO2 est idéal pour graver et découper des matériaux non métalliques (bois, acrylique, cuir, etc.). Le laser fibre est spécialisé dans la découpe de métaux (acier, inox, aluminium). Les machines mixtes combinent les deux technologies.'
  },
  {
    id: 'faq-2',
    question: 'Formation et prise en main : comment ça se passe ?',
    answer: 'Nous incluons une formation complète à l\'achat de votre machine. Formation sur site ou dans nos locaux, prise en main de la machine et du logiciel. Vous repartez autonome et confiant.'
  },
  {
    id: 'faq-3',
    question: 'Quel est le délai de livraison ?',
    answer: 'Le délai varie selon le modèle choisi, généralement entre 4 et 8 semaines. Nous vous informons précisément lors de votre commande.'
  },
  {
    id: 'faq-4',
    question: 'Le SAV est-il vraiment réactif ?',
    answer: 'Oui ! Notre équipe technique est disponible par téléphone, email et à distance. Nous intervenons rapidement pour résoudre vos problèmes et minimiser les temps d\'arrêt.'
  },
  {
    id: 'faq-5',
    question: 'Puis-je voir une machine avant d\'acheter ?',
    answer: 'Absolument ! Nous organisons des démonstrations dans nos locaux ou chez nos clients partenaires. Contactez-nous pour planifier une visite.'
  },
  {
    id: 'faq-6',
    question: 'Quelles sont les options de financement ?',
    answer: 'Nous travaillons avec plusieurs organismes de financement pour vous proposer des solutions adaptées : leasing, crédit professionnel, etc. Parlons-en lors de votre demande de devis.'
  }
];



// Machines d'occasion
export const usedMachines = {
  available: [
    {
      id: 'used-1',
      name: 'LaserCO2 Studio 600 - Occasion',
      type: 'CO2',
      power: '60W',
      workArea: '600 x 400 mm',
      year: '2022',
      condition: 'Très bon état',
      hours: '1200h d\'utilisation',
      price: '4 500 €',
      originalPrice: '7 200 €',
      image: 'https://images.pexels.com/photos/7254462/pexels-photo-7254462.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      description: 'Machine d\'occasion en excellent état. Idéale pour débuter ou pour un petit atelier. Révisée et testée dans nos ateliers.',
      included: ['Machine révisée', 'Logiciel', 'Formation 2h offerte', 'Garantie 6 mois'],
      status: 'available'
    },
    {
      id: 'used-2',
      name: 'LaserFibre Compact 1500 - Occasion',
      type: 'Fibre',
      power: '1500W',
      workArea: '2000 x 1000 mm',
      year: '2021',
      condition: 'Bon état',
      hours: '2800h d\'utilisation',
      price: '15 900 €',
      originalPrice: '28 000 €',
      image: 'https://images.unsplash.com/photo-1764114440880-9bdbfe570a4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxtZXRhbCUyMGN1dHRpbmd8ZW58MHx8fHwxNzc1MjA4NzkzfDA&ixlib=rb-4.1.0&q=85',
      description: 'Laser fibre professionnel d\'occasion. Parfait pour démarrer dans la découpe métal. Machine contrôlée et calibrée.',
      included: ['Machine révisée', 'Logiciel professionnel', 'Formation 3h offerte', 'Garantie 6 mois'],
      status: 'available'
    }
  ],
  sold: [
    {
      id: 'sold-1',
      name: 'LaserCO2 Pro 1000',
      type: 'CO2',
      power: '100W',
      workArea: '1000 x 600 mm',
      soldDate: 'Décembre 2024',
      soldPrice: '8 900 €',
      image: 'https://images.unsplash.com/photo-1615286922420-c6b348ffbd62?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxsYXNlciUyMGVuZ3JhdmluZ3xlbnwwfHx8fDE3NzUyMDg3OTB8MA&ixlib=rb-4.1.0&q=85',
      status: 'sold'
    },
    {
      id: 'sold-2',
      name: 'LaserFibre Metal 2000',
      type: 'Fibre',
      power: '2000W',
      workArea: '3000 x 1500 mm',
      soldDate: 'Novembre 2024',
      soldPrice: '24 500 €',
      image: 'https://images.unsplash.com/photo-1598302936625-6075fbd98dd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxtZXRhbCUyMGN1dHRpbmd8ZW58MHx8fHwxNzc1MjA4NzkzfDA&ixlib=rb-4.1.0&q=85',
      status: 'sold'
    },
    {
      id: 'sold-3',
      name: 'LaserCO2 Expert 1300',
      type: 'CO2',
      power: '130W',
      workArea: '1300 x 900 mm',
      soldDate: 'Novembre 2024',
      soldPrice: '11 200 €',
      image: 'https://images.pexels.com/photos/7254410/pexels-photo-7254410.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      status: 'sold'
    }
  ]
};
